<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :search-items="searchItems"
    :table-options="tableOptions"
    :form-items="formItems"
  />
</template>
<script>
export default {
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'clinic/clinicdic/clinicmedicinedic/clinicmateriel',
      // Web路径
      webPath: 'base/dictionary/medicine_dic/materiel_type',
      tableOptions: ['synchronization'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "name",
              name: "名称",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "typeSign",
              name: "类型标识",
              span: 6,
              type: "select",
              config: {
                edit: false,
                options: [
                  { key: "1", value: "中成药" },
                  { key: "2", value: "西药" },
                  { key: "3", value: "饮片" },
                  { key: "4", value: "服务" },
                  { key: "5", value: "产品" }
                ]
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "code",
          name: "编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "name",
          name: "名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "typeSign",
          name: "类型标识",
          span: 6,
          type: "select",
          config: {
            edit: false,
            options: [
              { key: "1", value: "中成药" },
              { key: "2", value: "西药" },
              { key: "3", value: "饮片" },
              { key: "4", value: "服务" },
              { key: "5", value: "产品" }
            ]
          }
        },
        {
          code: "storeRatio",
          name: "门店分成比例",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "platformRatio",
          name: "平台分成比例",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "agentRatio",
          name: "代理商分成比例",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false,
                rules: [
                  { required: true, message: "请输入编码", trigger: "blur" }
                ]
              }
            },
            {
              code: "name",
              name: "名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                rules: [
                  { required: true, message: "请输入名称", trigger: "blur" }
                ]
              }
            },
            {
              code: "typeSign",
              name: "类型标识",
              span: 6,
              type: "select",
              config: {
                edit: false,
                defaultValue: '1',
                options: [
                  { key: "1", value: "中成药" },
                  { key: "2", value: "西药" },
                  { key: "3", value: "饮片" },
                  { key: "4", value: "服务" },
                  { key: "5", value: "产品" }
                ]
              }
            },
            {
              code: "storeRatio",
              name: "门店分成比例",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "platformRatio",
              name: "平台分成比例",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "agentRatio",
              name: "代理商分成比例",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
